let enqueueSnackbarRef;

export const setSnackBar= (enqueueSnackBar) => {
  enqueueSnackbarRef = enqueueSnackBar;
}

export const showSnackBar = (message,options) => {
  if(enqueueSnackbarRef) {
    enqueueSnackbarRef(message, options);
  } else {
    console.warn('SnackbarProvier not initialized')
  }
}